export const BLOG_CONTENT = 'js-blog-content';

export const EMAIL_SUBSCRIPTION_TAG_NAME = 'email-subscription-cta';
export const EMAIL_SUBSCRIPTION_SAMPLE_CLASS = 'js-blog-email-subscription-sample';

export const PODCAST_SUBSCRIPTION_TAG_NAME = 'podcast-subscription';
export const PODCAST_SUBSCRIPTION_SAMPLE_CLASS = 'js-blog-podcast-subscription-sample';

export const AUDIO_TAG_NAME = 'audio-placeholder';
export const AUDIO_CLASS_NAME = 'blog__audio';

export const VIDEO_TAG_NAME = 'iframe[src*="youtube"]';
export const VIDEO_CLASS_NAME = 'blog__video';

export const TABLE_OF_CONTENTS_TAG_NAME = 'table-of-contents';
export const TABLE_OF_CONTENTS_REFERENCE_TAG_NAME = 'a';
export const TABLE_OF_CONTENTS_TITLE_REFERENCE = 'table-of-contents__title-reference';
export const TABLE_OF_CONTENTS_SUBTITLE_REFERENCE = 'table-of-contents__subtitle-reference';
export const TABLE_OF_CONTENTS_TITLE_TAG = 'H2';
export const TABLE_OF_CONTENTS_SUBTITLE_TAG = 'H3';
export const TABLE_OF_CONTENTS_REFERENCE_TEXT_CONTAINER = 'div';
export const TABLE_OF_CONTENTS_REFERENCE_CONTAINER = 'js-table-of-contents-reference-container';
export const TABLE_OF_CONTENTS_SAMPLE = 'js-table-of-contents-sample';
export const TABLE_OF_CONTENTS_REFERENCE_SAMPLE = 'js-table-of-contents-reference-sample';

export const ALL_POSTS_LIST = 'js-all-posts-list';
export const ALL_POSTS_LIST_COLLAPSED = 'blog-collection__all-articles-container--collapsed';
export const VIEW_ALL_POSTS_BUTTON = 'js-posts-show-all';

export const PINTEREST_BUTTON = 'js-pinterest-button';

export const BLOG_NAVBAR_CONTAINER = 'js-blog-navigation-container';
export const BLOG_SHOP_KETONE_BUTTON = 'js-blog-shop-ketone-button';
